/* tslint:disable */
/* eslint-disable */
/**
 * (S-CAPI-DDMS)図面書類管理サービス向け
 * 図面書類管理サービス向けAPI ※ API Management経由でアクセスする場合はRequestHeaderにxgrab-api-key(API Managementのサブスクリプションキー)が必要となるが、本資料としては省略している 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: 1234567890abcd@co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 対象区分
 * @export
 * @interface TargetType
 */
export interface TargetType {
    /**
     * 対象区分<br> TAG：内容タグ<br> RACK：データラック
     * @type {string}
     * @memberof TargetType
     */
    target_type?: TargetTypeTargetTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TargetTypeTargetTypeEnum {
    Tag = 'TAG',
    Rack = 'RACK'
}



